import React from "react";

const Roles = () => {
  return <div>Roles</div>;
};

export default Roles;
